module.exports = __webpack_public_path__ + "static/img/关于我们-创始人照片.4627bbc5.png";